export const SECONDARY_MARKET_GET_PREDICTED_ASSET_PRICE_START = 'SECONDARY_MARKET_GET_PREDICTED_ASSET_PRICE_START';
export const SECONDARY_MARKET_GET_PREDICTED_ASSET_PRICE_SUCCESS = 'SECONDARY_MARKET_GET_PREDICTED_ASSET_PRICE_SUCCESS';
export const SECONDARY_MARKET_GET_PREDICTED_ASSET_PRICE_FAILED = 'SECONDARY_MARKET_GET_PREDICTED_ASSET_PRICE_FAILED';
export const SECONDARY_MARKET_GET_PREDICTED_ASSET_PRICE = 'SECONDARY_MARKET_GET_PREDICTED_ASSET_PRICE';

export const SECONDARY_MARKET_GET_MOST_SALES_ASSETS_START = 'SECONDARY_MARKET_GET_MOST_SALES_ASSETS_START';
export const SECONDARY_MARKET_GET_MOST_SALES_ASSETS_FAILED = 'SECONDARY_MARKET_GET_MOST_SALES_ASSETS_FAILED';

export const DROP_PREDICT_PRICE_DATA = 'DROP_PREDICT_PRICE_DATA';
